/* ============
 * packageUnitType Module Mutations
 * ============
 */

import {
  FETCH_ALL_PACKAGE_ORDER_PRODUCTS,
} from './../../mutation-types';

export default {
  [FETCH_ALL_PACKAGE_ORDER_PRODUCTS](state, packageOrderProduct) {
    state.all = packageOrderProduct;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/packageOrderProduct/mutations.js